import { ApiPaths } from './ApiPaths';
import BaseApi from './BaseApi';

/**
 * API for tracking search and data retreival
 * @param {String} baseURL
 */
const create = () => {
    
    const api = BaseApi.create({});

    const createSearchLog = (action) => {
       var payload = {
           "id": action.data.id,
           "type": action.data.type
        }
        return api.post(ApiPaths.AUDIT , payload);
    }   
    // Return back a collection of functions
    return { createSearchLog }
}

// let's return back our create method as the default.
export default {
    create
}
